import React from 'react'
import styles from '../../../styles/patientStyles/EducationInfo.module.css'

import HeaderWithMenu from '../../../components/patientComponents/component/headerWithMenu/index'
import BackButton from '../../../components/patientComponents/component/backButton'
import CautionCard from '../../../components/patientComponents/component/cautionCard'
import Footer from '../../../components/patientComponents/component/footer'
import EducationCard3 from '../../../components/patientComponents/component/Education/educationCard3'

const Education3 = () => {
  return (
    <>
      <div className={styles.innerContainer}>
        <HeaderWithMenu />
        <BackButton />
        <div className={`${styles.title}`}>
          Documentos que debe tener en cuenta, cuando vaya a realizar su
          procedimiento
        </div>
        <div className={styles.imgContainer}>
          <EducationCard3 />
          {/*  <img
            className={`${styles.img}`}
            src="/educacion-art-2-01.jpg"
            alt="Info"
          /> */}
        </div>
        <CautionCard
          text="En el caso que su dispensador le haya entregado el dispositivo médico
      ialuril® Prefill, debe llevarlo el día del procedimiento"
        />
      </div>
      <Footer />
    </>
  )
}

export default Education3
